import { Injectable } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { BookingDto, TowerGroupDto, PaymentConfigurationDto, PaymentAmountDto } from 'src/app/api/models';
import { StorageService } from 'src/app/core/services/storage.service';
import { DateFormat, StorageEnums, BookingStatus } from 'src/shared/models/enums';
import { CustomBookingDTO, BookingAtTheGate } from 'src/shared/models/global.model';
import { DateHelperService } from './date-helper.service';
import { SharedBookingAccessHelperService } from 'src/app/modules/shared-booking-access/services/shared-booking-access-helper.service';
import { BookingStepsComponent } from 'src/app/modules/bookings/booking-steps/booking-steps.component';
import { AlertController, ModalController } from '@ionic/angular/standalone';
import { ActivatedRoute, Router } from '@angular/router';
import { UserBookingsApiService, UserTowerGroupsApiService } from 'src/app/api/services';
import { CustomSpinnerService } from './custom-spinner.service';
import { catchError, shareReplay, startWith, switchMap, take } from 'rxjs/operators';
import { ContactUsPage } from 'src/app/modules/support-wrapper/contact-us/contact-us.page';
import { DoorStatusComponent } from 'src/app/modules/bookings/door-status/door-status.component';
import { PaymentObject } from 'src/shared/models/payment.model';
import { Observable, Subscription, timer } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class BookingHelperService {
	contactUsModal: HTMLIonModalElement;
	doorStatusModal: HTMLIonModalElement;
	private subscriptions: Map<string, Subscription> = new Map();
	private observablesCache: Map<string, Observable<string>> = new Map();
	constructor(private storage: StorageService,
				private translateService: TranslateService,
				private modalCtrl: ModalController,
				private alertCtrl: AlertController,
				private translate: TranslateService,
				private activatedRoute: ActivatedRoute,
				private bookingApiService: UserBookingsApiService,
				private router: Router,
				private groupsService: UserTowerGroupsApiService,
				private loader: CustomSpinnerService,
				private shareHelper: SharedBookingAccessHelperService) {
	}

	/**
	 * math.ceil((d+mp+abs(d-mp))/(2*u))*r
	 */
	calculateCosts(mp, u, r, d, dailyCapPrice) {
		const restOfDay = d % 1440;
		const numberOfFullDays = (d - restOfDay)/1440;
		const priceOfDay = Math.min((Math.ceil((1440 + mp + Math.abs(1440 - mp)) / (2 * u)) * r), dailyCapPrice);
		const priceOfRestDay = Math.min((Math.ceil((restOfDay + mp + Math.abs(restOfDay - mp)) / (2 * u)) * r), dailyCapPrice);
		return (priceOfDay * numberOfFullDays + priceOfRestDay).toFixed(2);
	}

	calcTimeBySubscription(start, left) {
		console.log('left', start, left);
		let now = moment();
		const startForSubs = moment(start);
		let startMoment = moment(start);
		const startForExtra = startMoment.add(left, 'minute');
		console.log('startForExtra', startForExtra.format(DateFormat.DefaultFormat));

		const durationSubs = moment.duration(now.diff(startForSubs));
		//WOrks!
		const durationExtra = moment.duration(now.diff(startForExtra));
		let resSubsDuration = this.calcTime(durationSubs.subtract(durationExtra.asMinutes(), 'minute'), false);
		let resExtraDuration = this.calcTime(durationExtra, false);

		return {
			subsDuration: resSubsDuration,
			extraDuration: resExtraDuration
		}
	}

	async openSupport(inputGroup?: TowerGroupDto) {
		this.contactUsModal = await this.modalCtrl.create({
			component: ContactUsPage,
			backdropDismiss: false,
			cssClass: 'auto-height',
			componentProps: {
				fromModal: true,
				inputGroup
			}
		});
		await this.contactUsModal.present().then(() => {
			
		});
		await this.contactUsModal.onDidDismiss().then(() => {
		});
		return this.contactUsModal;
	}

	async closeContactUs() {
		if (this.contactUsModal) await this.contactUsModal.dismiss();
	}

	async openDoorModal(status: BookingStatus, booking: CustomBookingDTO, group: TowerGroupDto, towerStatus?: string, doorAction: boolean = false) {
		this.doorStatusModal = await this.modalCtrl.create({
			component: DoorStatusComponent,
			cssClass: 'auto-height full-height',
			backdropDismiss: false,
			componentProps: {
				status,
				facility: group.label,
				group: group,
				sharedWithMe: booking.sharedWithMe,
				bookingId: booking.id,
				booking: booking,
				towerStatus,
				doorAction
			}
		});
		return this.doorStatusModal;
	}

	async closeDoorModal(data: any) {
		if(this.doorStatusModal) await this.doorStatusModal.dismiss(data);
	}

	async OpenDoorAgain(callBack1, callBack2, callBack3) {
		const alertObj = {
			header: 'alerts.attention',
			message: 'alerts.open-door',
			button1: 'buttons.try-again',
			button2: 'contact-us.contact-support',
			button3: 'buttons.cancel'
		};
		const alert = await this.alertCtrl.create({
			cssClass: 'forgot-password-alert',
			mode: 'ios',
			header: this.translate.instant(alertObj.header),
			message: this.translate.instant(alertObj.message),
			buttons: [
				{
					text: this.translate.instant(alertObj.button1),
					handler: () => {
						callBack1();
					}
				},
				{
					text: this.translate.instant(alertObj.button2),
					cssClass: 'button-outline',
					handler: () => {
						callBack2();
					}
				},
				{
					text: this.translate.instant(alertObj.button3),
					cssClass: 'button-outline',
					handler: () => {
						callBack3();
					}
				}
			]
		});

		await alert.present();
	}

	async openGroupIdInModal(groupIdToOpen, stepToOpen, isPublic: boolean = false, fromBuySubscription: boolean = false) {
		await this.loader.show();
		if (groupIdToOpen) {
			const groupsRequest = isPublic ? this.groupsService.getUserTowerGroups1(): this.groupsService.getUserTowerGroups();
			groupsRequest.pipe(take(1)).subscribe(async (groups) => {
				const foundGroup = groups.find(v => v.id == groupIdToOpen);
				if (foundGroup) {         
				await this.openTowerModal(foundGroup, Number(stepToOpen), fromBuySubscription);
				await this.loader.hide();
				}
			});
		}
	}

	async openTowerModal(g: TowerGroupDto, step = null, fromBuySubscription: boolean = false) {
		let componentProps = {
		  group: g,
		  fromBuySubscription
		};
		if (step) {
		  componentProps = {
			...componentProps,
			...{
			  currentStep: step
			}
		  };
		}
		const modal = await this.modalCtrl.create({
		  id: 'booking-details',
		  component: BookingStepsComponent,
		  cssClass: 'auto-height',
		  componentProps: componentProps
		});
		
		modal.onWillDismiss().then(async v => {
		  await this.router.navigate([], {
			relativeTo: this.activatedRoute
		  });
		});
		modal.present();
	}

	calcTimeWithOffset(minutes, onlyHours = false): any {
		let to = moment();
		let from = moment().subtract(minutes, 'minute');
		const durationSubs = moment.duration(to.diff(from));
		return this.calcTime(durationSubs, false, onlyHours);
	}

	calculateTimeList(bookings) {
		return bookings.map(b => Math.ceil(moment.duration(moment().diff(b.startDate)).asMinutes())).reduce((a, b) => a + b, 0);
	}

	calculateTime(start, withSeconds = true) {
		let now = moment();
		const duration = moment.duration(now.diff(start));
		// console.log('duration', duration);
		return {
			hours: Math.ceil(duration.asHours()),
			time: this.calcTime(duration, withSeconds)
		};
	}

	calculateTimeBetweenStartAndEnd(start, end, withSeconds = true) {
		const now = moment(end);
		const duration = moment.duration(now.diff(start));		
		const durationFormated = duration.asSeconds() > 0 ? duration: moment.duration(1);
		return {
			hours: Math.ceil(durationFormated.asHours()),
			time: this.calcTime(durationFormated, withSeconds)
		};
	}

	calcTime(duration: moment.Duration, withSeconds, onlyHours = false) {
		let res = '';

		var days = Math.floor(duration.asDays());
		if (!onlyHours) {
			duration.subtract(moment.duration(days, 'days'));
		}

//Get hours and subtract from duration
		var hours;
		if (!onlyHours) {
			hours = duration.hours();
		} else {
			hours = +duration.asHours().toFixed(0);
		}
		duration.subtract(moment.duration(hours, 'hours'));

//Get Minutes and subtract from duration
		var minutes = duration.minutes();
		duration.subtract(moment.duration(minutes, 'minutes'));

//Get seconds
		var seconds = duration.seconds();
		if (days !== 0 && !onlyHours) {
			res += `${ days } ${ days > 1 ? this.translateService.instant('time-periods.days') : this.translateService.instant('time-periods.day') } `
		}

		if (hours !== 0) {
			res += `${ hours } h `
		}
		if (minutes > 0) {
			res += `${ minutes } min`
		}

		if ((withSeconds || minutes === 0) && !onlyHours) {
			res += ` ${ seconds } sec`
		}

		return res.toLowerCase();
	}

	convertBooking(b: BookingDto, groups: Array<TowerGroupDto>, wasDoorOpen, myBookings: boolean) {
		let oldDate = b.startDate;
		let towerGroupDto = groups.find(g => g.label === b.towerGroupName);
		let payment: PaymentConfigurationDto;
		if (towerGroupDto) {
			payment = towerGroupDto.paymentConfigurations.find(p => p.type === 'PAY_PER_USE')
		} else {
			payment = null;
		}
		let calcTime = this.calculateTime(oldDate, true);
		let result: CustomBookingDTO = Object.assign(b,
			{
				costs: '',
				wasDoorOpen,
				// orders: 23,
				timePassed: calcTime.time,
				payment: payment
			});

		if (myBookings) {
			result = {
				...result, ...{
					sharedBookingsAccessCount: b?.sharesCount?.total,
					activeSharedBookingsAccessCount: b?.sharesCount?.accepted
				}
			}
		} else {
			result = {
				...result, ...{
					isSharingActive: this.shareHelper.checkIfSharingIsActive(b.startDate, b.endDate, b['sharedStatus'])
				}
			}
		}
		return result;
	}

	convertBookingForSteps(b: BookingDto, group: TowerGroupDto) {
		let oldDate = b.startDate;
		let calcTime = this.calculateTime(oldDate, true);
		const result: CustomBookingDTO = Object.assign(b,
			{
				costs: '',
				timePassed: calcTime.time,
				payment: group.paymentConfigurations.find(p => p.type === 'PAY_PER_USE')
			});
		return result;
	}

	async convertBookings(bookings: Array<BookingDto>, groups: Array<TowerGroupDto>, myBookings: boolean): Promise<CustomBookingDTO[]> {
		let bookingsFromStorage: Array<CustomBookingDTO> = await this.storage.getItem(StorageEnums.Bookings);
		let customBookingDTOS = bookings.map(b => {
			let doorOpened = false;
			if (bookingsFromStorage) {
				let bookingFromStorage = bookingsFromStorage.find(book => book.id === b.id);

				if (bookingFromStorage) {
					doorOpened = bookingFromStorage.wasDoorOpen;
				}
			}

			return this.convertBooking(b, groups, doorOpened, myBookings);
		});
		if (!myBookings) {

			customBookingDTOS.sort((a, b) => {
				if (a.sharedStatus === 'INVITED') {
					return -1;
				} else if (a.startDate > b.startDate) {
					return 1;
				} else {
					return 0;
				}
			});
		} else {
			customBookingDTOS.sort((a, b) => {
				if (a.startDate < b.startDate) {
					return 1;
				}
				if (a.startDate > b.startDate) {
					return -1;
				}
				return 0;
			});
		}
		return customBookingDTOS;
	}

	recalculateBookings(booking: Array<CustomBookingDTO>) {
		booking.forEach(b => {
			this.recalculateBooking(b);
		})
	}

	recalculateBooking(b: CustomBookingDTO) {
		const p = b.payment;
		b.timePassed = this.calculateTime(b.startDate, true).time;
		let d = DateHelperService.durationInMinutes(b.startDate);
		b.fiveMinLeft = d >= 5;
	}

	async handleOpenBooking(booking: CustomBookingDTO) {
		booking.wasDoorOpen = true;
		let bookings: Array<CustomBookingDTO> = await this.storage.getItem(StorageEnums.Bookings);
		// console.log('bookings found', bookings);
		if (bookings) {
			let index = bookings.findIndex(b => b.id === booking.id);
			// console.log('index', index);
			if (index != -1) {
				bookings[index] = booking;
			} else {
				bookings.push(booking);
			}

			// console.log('bookings', bookings);
			await this.storage.setItem(StorageEnums.Bookings, bookings);
		} else {
			bookings = []
			bookings.push(booking);
			// console.log('setNewBookings', bookings);
			await this.storage.setItem(StorageEnums.Bookings, bookings);
		}
	}

	/**
	 *  The function decides remove or not booking from
	 * @param booking
	 */
	async handleTerminateBooking(id) {
		let bookings: Array<CustomBookingDTO> = await this.storage.getItem(StorageEnums.Bookings);
		if (bookings) {
			const index = bookings.findIndex(b => b.id === id);
			if (index > -1) {
				bookings.splice(index, 1);
			}

			await this.storage.setItem(StorageEnums.Bookings, bookings);
		}
	}


	async addBookingAtTheGate(id) {
		const bookingAtTheGate: BookingAtTheGate = {
			id: id,
			status: BookingStatus.DoorsIsOpening
		}
		await this.storage.setItem(StorageEnums.BookingAtTheGate, bookingAtTheGate);
	}

	async removeBookingAtTheGate() {
		await this.storage.removeItem(StorageEnums.BookingAtTheGate);
	}

	convertSubscription(sub) {
		if (!sub) {
			return null;
		}

		if (Number.isInteger(sub.capacity)) {
			// sub.capacity = this.calcTimeWithOffset(Number(sub.capacity), true);
		}

		sub.rate = sub.rate ? (+sub.rate).toFixed(2) : '';
		let date = DateHelperService.datePlus30days(sub.startDateSub);
		let newVar = {
			...sub, ...{
				start: date.start,
				end: date.end,
				duration: 30
			}
		};
		return newVar
	}

	async startBookingConfirm(onSuccess) {
		const alert = await this.alertCtrl.create({
			cssClass: 'forgot-password-alert',
			mode: 'ios',
			header: this.translate.instant('alerts.attention'),
			message: this.translate.instant('booking-steps.info.start-without'),
			buttons: [
				{
					text: this.translate.instant('buttons.yes'),
					handler: () => {
						onSuccess();
					},
				},
				{
					text: this.translate.instant('buttons.no'),
					handler: () => {
					}
				}
			]
		});
		await alert.present();
	}

	async showPincode(pin: string, onSuccess) {
		const alert = await this.alertCtrl.create({
			cssClass: 'forgot-password-alert pinpad',
			mode: 'ios',
			header: this.translate.instant('pinpad.access-code'),
			subHeader: pin.replace(/\d{2}(?!$)/g, "$& "),
			buttons: [
				{
					text: this.translate.instant('buttons.ok'),
					handler: () => {
					},
				},
				{
					text: this.translate.instant('pinpad.reset-access-code'),
					handler: () => {
						onSuccess();
					},
				}
			]
		});
		await alert.present();
	}

	towerReadyToAction(type: PaymentObject, callback: (valid: boolean) => void, bookingId: number = null, towerGroupId: number = null, onDateTime: string = null ) {
		if (type === PaymentObject.Subscription) {
		  this.groupsService.canSubscribeToTowerGroup({id: towerGroupId, onDateTime}).pipe(
			catchError(async (error) => {
			  return ({value: 'false'});
			})
		  ).subscribe(response => {
			const valid = response.value === 'true';
			if(!valid) {
				this.showCantSubscribeAlert();
				this.loader.hide();
			}
			 callback(valid);
		  });
		} else if ((type === PaymentObject.Booking) || (type === PaymentObject.PayPerUse)) {
		  this.bookingApiService.getBookingReadyToTerminate({bookingId}).pipe(
			catchError(async (error) => {
			  return ({value: false});
			})
		  ).subscribe(response => {
			const valid = response.value === true;
			if(!valid) {
				this.showCantTerminateAlert();
				this.loader.hide();
			}
			callback(valid);
		  });
		}
		else if (type === PaymentObject.Purchase) {
			this.loader.hide();
			return callback(true);
		}
	}

	async showCantSubscribeAlert() {
		const alert = await this.alertCtrl.create({
			cssClass: 'forgot-password-alert',
			header: this.translateService.instant('alerts.title'),
			message: this.translateService.instant('subscriptions.another-time'),
			mode: 'ios',
			buttons: [{
				text: this.translateService.instant('buttons.continue')
			}]
		});
		await alert.present();
	}

	async showCantTerminateAlert() {
		const alert = await this.alertCtrl.create({
			cssClass: 'forgot-password-alert',
			header: this.translateService.instant('alerts.title'),
			message: this.translateService.instant('booking-steps.info.cant-terminate'),
			mode: 'ios',
			buttons: [{
				text: this.translateService.instant('buttons.continue')
			}]
		});
		await alert.present();
	}

	calculateCost(booking: CustomBookingDTO, groups: Array<TowerGroupDto>, intervalSec = 60): Observable<string> {
		const currencyCode = groups?.find(g => g?.label === booking?.towerGroupName)?.currencyCode;
	
		if (!booking || !currencyCode) {
		  return new Observable<string>(observer => {
			observer.next('-');
		  });
		}
	
		const cacheKey = Number(booking.id) + currencyCode;
		if (this.observablesCache.has(cacheKey)) {
		  return this.observablesCache.get(cacheKey)!;
		}
	
		const observable = new Observable<string>(observer => {
		const initialDelay = this.calculateInitialDelay(booking.startDate) + 3000;
		const subscription = timer(initialDelay, (intervalSec + 10) * 1000).pipe(
			startWith(0), // Start immediately
			switchMap(() => this.makeRequest(booking))
		).subscribe(response => {
			const cost = response.amount?.toFixed(2);
			observer.next(cost + ' ' + currencyCode);
		}, error => {
			observer.next('-');
		});
	
		this.subscriptions.set(cacheKey, subscription);
	
		return () => {
			subscription.unsubscribe();
			this.subscriptions.delete(cacheKey);
			this.observablesCache.delete(cacheKey);
		};
		}).pipe(
		  shareReplay({ bufferSize: 1, refCount: true }) // Share the observable and replay last emitted value
		);
	
		this.observablesCache.set(cacheKey, observable);
	
		return observable;
	}

	private calculateInitialDelay(startDate: string): number {
		const now = new Date();
		const start = new Date(startDate);
		const elapsedTime = now.getTime() - start.getTime();
		const timeToNextMinute = 60000 - (elapsedTime % 60000);
		return timeToNextMinute;
	}
	
	private makeRequest(booking: CustomBookingDTO): Observable<PaymentAmountDto> {
		return this.bookingApiService.getAmount({ bookingId: booking.id, freeHours: 0 });
	}
	
	unsubscribeAll() {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
		this.subscriptions.clear();
		this.observablesCache.clear();
	}
}